module.exports = __webpack_public_path__ + "img/Businessexplorationselect.5ddffb78.svg";